import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { MapCollectAccounts, MapCustomerPaymentProfiles } from "@sonic/Handlers/Utilities";

export type HandlerType = Parameters<typeof GetCart>[0];

addToChainAfter(chain, GetCart, ParseCustomPropertyData);

function ParseCustomPropertyData(props: HandlerType) {
    MapCollectAccounts(props.apiResult!.cart);
    MapCustomerPaymentProfiles(props.apiResult!.cart);
}
